module.exports = __webpack_public_path__ + "static/media/icon_checkin2.08a9a17c.svg";